import React from 'react';
import { TextLink } from 'ui/components/styled';

export const TimeoutLink = ({
  children,
  timeout = 60,
  component: Component = TextLink,
  ...rest
}) => {
  const [disabled, setDisabled] = React.useState(timeout > 0);
  const [countdown, setCountdown] = React.useState(timeout);

  React.useEffect(() => {
    let counter = timeout;
    const interval = setInterval(() => {
      counter--;
      setCountdown(counter);
      if (counter === 0) {
        clearInterval(interval);
        setDisabled(false);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Component {...rest} disabled={disabled}>
      {children} {countdown > 0 && `(${countdown})`}
    </Component>
  );
};
